import { useState, useContext } from 'react'
import { Link } from 'react-router-dom'
import { FiUserPlus } from 'react-icons/fi'

import Input from '../../shared/components/form/Input'
import PasswordChecklist from '../../shared/components/form/PasswordChecklist'
import { Context } from '../../context/UserContext'

import './auth.css'

function Register() {
    const [user, setUser] = useState({})
    const [loading, setLoading] = useState(false)
    const { register } = useContext(Context)

    function handleChange(e) {
        setUser({ ...user, [e.target.name]: e.target.value })
    }

    async function handleSubmit(e) {
        e.preventDefault()
        setLoading(true)
        await register(user)
        setLoading(false)
    }

    return (
        <div className="auth">
            <div className="auth-box panel">
                <p className="auth-eyebrow">Novo recruta</p>
                <h1 className="auth-title">Criar conta</h1>
                <p className="auth-subtitle">Cadastre-se pra começar a acumular pontos e subir no ranking.</p>

                <form onSubmit={handleSubmit} className="auth-form">
                    <Input
                        text="Nome"
                        type="text"
                        name="name"
                        placeholder="Seu nome completo"
                        handleOnChange={handleChange}
                        value={user.name || ''}
                    />
                    <Input
                        text="Data de nascimento"
                        type="date"
                        name="birth"
                        handleOnChange={handleChange}
                        value={user.birth || ''}
                    />
                    <Input
                        text="Email"
                        type="email"
                        name="email"
                        placeholder="voce@email.com"
                        handleOnChange={handleChange}
                        value={user.email || ''}
                    />
                    <Input
                        text="Usuário (Apelido)"
                        type="text"
                        name="userName"
                        placeholder="Como quer ser chamado na arena"
                        handleOnChange={handleChange}
                        value={user.userName || ''}
                    />
                    <Input
                        text="Senha"
                        type="password"
                        name="password"
                        handleOnChange={handleChange}
                        value={user.password || ''}
                    />
                    <PasswordChecklist password={user.password} />
                    <Input
                        text="Confirmar senha"
                        type="password"
                        name="confirmPassword"
                        placeholder="Repita a senha"
                        handleOnChange={handleChange}
                        value={user.confirmPassword || ''}
                    />

                    <button className="btn-primary auth-submit" type="submit" disabled={loading}>
                        <FiUserPlus size={16} />
                        {loading ? 'Cadastrando...' : 'Cadastrar'}
                    </button>
                </form>

                <p className="auth-switch">
                    Já tem conta? <Link to="/login">Entrar</Link>
                </p>
            </div>
        </div>
    )
}

export default Register
